import { render } from "./WorkspaceAccessDenied.vue?vue&type=template&id=24c7ae15&scoped=true&ts=true"
import script from "./WorkspaceAccessDenied.vue?vue&type=script&lang=ts"
export * from "./WorkspaceAccessDenied.vue?vue&type=script&lang=ts"

import "./WorkspaceAccessDenied.vue?vue&type=style&index=0&id=24c7ae15&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c7ae15"]])

export default __exports__